// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3QOFJ","title":"styles_title__8eTBG"};